import apiClient, { ApiResponse, PaginatedResponse } from '../api/client';
import { Module } from '../types/models';

export interface ModuleFilters {
  search?: string;
  is_active?: boolean;
  page?: number;
  per_page?: number;
}

export interface CreateModuleData {
  name: string;
  description?: string;
  module_type_id: number;
  status?: string;
  icon?: string;
  priority_order?: number;
}

export interface UpdateModuleData extends Partial<CreateModuleData> {
  status?: string;
}

class ModuleService {
  private baseUrl = '/admin/county/modules';

  async getModules(filters?: ModuleFilters): Promise<ApiResponse<PaginatedResponse<Module>>> {
    const params = new URLSearchParams();
    if (filters?.search) params.append('search', filters.search);
    if (filters?.is_active !== undefined) params.append('is_active', filters.is_active.toString());
    if (filters?.page) params.append('page', filters.page.toString());
    if (filters?.per_page) params.append('per_page', filters.per_page.toString());

    return apiClient.get<PaginatedResponse<Module>>(`${this.baseUrl}?${params.toString()}`);
  }

  async getModule(id: number): Promise<ApiResponse<Module>> {
    return apiClient.get<Module>(`${this.baseUrl}/${id}`);
  }

  async createModule(data: CreateModuleData): Promise<ApiResponse<Module>> {
    return apiClient.post<Module>(this.baseUrl, data);
  }

  async updateModule(id: number, data: UpdateModuleData): Promise<ApiResponse<Module>> {
    return apiClient.put<Module>(`${this.baseUrl}/${id}`, data);
  }

  async deleteModule(id: number): Promise<ApiResponse> {
    return apiClient.delete(`${this.baseUrl}/${id}`);
  }

  async toggleStatus(id: number): Promise<ApiResponse<Module>> {
    return apiClient.post<Module>(`${this.baseUrl}/${id}/toggle-status`);
  }

  async getModuleDashboard(id: number): Promise<ApiResponse<any>> {
    return apiClient.get<any>(`${this.baseUrl}/${id}/dashboard`);
  }

  async getModuleTypes(): Promise<ApiResponse<any[]>> {
    return apiClient.get<any[]>('/admin/county/module-templates/module-types');
  }
}

export const moduleService = new ModuleService();
export default moduleService;
